import React from 'react';
import { FlyoutMenuContainer } from './Container/FlyoutMenuContainer';
import { FlyoutMenuBackdrop } from './Backdrop/FlyoutMenuBackdrop';
export const FlyoutMenu = ({ children, opened = false, onClose, }) => {
    return (React.createElement(FlyoutMenuBackdrop, { opened: opened, onClose: onClose },
        React.createElement(FlyoutMenuContainer, { opened: opened, onClose: onClose }, children)));
};
//# sourceMappingURL=index.js.map